import Authentication from '../controllers/authentication';
import Product from '../controllers/product';
import Country from '../controllers/country';
import MessageCodes from '../config/messages';
import useAnalyticsEventTracker from '../components/analytics/analyticsEventtracker';

const Reducer = (state, action) => {
    const gaEventTracker = useAnalyticsEventTracker('GlobalContext');

    switch(action.type){
        case 'SET_AUTH': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()){
                return authObj.doLogin(action.payload)
                    .then(() => {
                        state.locale.setLocale(authObj.account.country.countryId);

                        return Promise.resolve({
                            ...state,
                            auth: authObj,
                            authenticated: authObj.isAuthenticated(),
                            authError: undefined
                        })
                    }).catch((err) => {
                        return Promise.resolve({
                            ...state,
                            auth: authObj,
                            authenticated: authObj.isAuthenticated(),
                            authError: err
                        });
                    });
            }

            return Promise.resolve(state);
        }
        case 'RESET_PASSWORD': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                return authObj.reset(action.payload)
                    .then((output) => {
                        return Promise.resolve({
                            ...state,
                            message: output.data //!!MessageCodes[output.data] ? MessageCodes[output.data].message : undefined
                        })
                    }).catch((err) => {
                        return Promise.resolve({
                            ...state,
                            error: err
                        });
                    });
            }
            return Promise.resolve(state);
        }
        case 'LOGOUT':
            return Promise.resolve(
                {
                    ...state,
                    auth: undefined,
                    authenticated: false
                }
            );

        case 'REGISTER': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                return authObj.register(action.payload)
                    .then((output) => {
                        return Promise.resolve({
                            ...state,
                            message: output.data //!!MessageCodes[output.data] ? MessageCodes[output.data].message : undefined
                        })
                    }).catch((err) => {
                        return Promise.resolve({
                            ...state,
                            error: err
                        });
                    });
            }
            return Promise.resolve(state);
        }
        case 'VERIFY_USER': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                return authObj.verify(action.payload)
                    .then((output) => {
                        return Promise.resolve({
                            ...state,
                            message: output.data //!!MessageCodes[output.data] ? MessageCodes[output.data].message : undefined
                        })
                    }).catch((err) => {
                        return Promise.resolve({
                            ...state,
                            error: err
                        });
                    });
            }
            return Promise.resolve(state);
        }
        case 'UPDATE_USER': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                authObj.doLogout();
            }

            return authObj.updateUser(action.payload)
                .then((output) => {
                    return Promise.resolve({
                        ...state,
                        message: output.data //!!MessageCodes[output.data] ? MessageCodes[output.data].message : undefined
                    })
                }).catch((err) => {
                    return Promise.resolve({
                        ...state,
                        error: err
                    });
                });
        }
        case 'UPDATE_USER_PASSWORD': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                authObj.doLogout();
            }

            return authObj.updatePassword(action.payload)
                .then((output) => {
                    return Promise.resolve({
                        ...state,
                        message: output.data //!!MessageCodes[output.data] ? MessageCodes[output.data].message : undefined
                    })
                }).catch((err) => {
                    return Promise.resolve({
                        ...state,
                        error: err
                    });
                });

        }
        case 'SET_UNAUTHORIZED': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            authObj.doLogout();
            return Promise.resolve({
                ...state,
                auth: authObj,
                authenticated: authObj.isAuthenticated()
            });
        }
        case 'QUERY_ACCOUNT_DATA': {
            let authObj = !!state.auth ? state.auth : new Authentication();
            if(!authObj.isValid()) {
                authObj.doLogout();
            }

            return Promise.resolve({
                ...state,
                auth: authObj,
                authenticated: authObj.isAuthenticated()
            });
        }
        case 'SET_QUERY_PRODUCTS': {
            let oQuery = (!!action.payload && !!action.payload.query) ? action.payload.query : (state.query || undefined );
            let lProducts = (!!action.payload && !!action.payload.list) ? action.payload.list : ( (!action.payload.query && state.products) || undefined );
            return Promise.resolve({
                ...state,
                query: oQuery,
                products: lProducts
            });
        }
        case 'RESET_QUERY': {
            return Promise.resolve({
                ...state,
                query: undefined,
                products: undefined
            });
        }
        case 'QUERY_PRODUCTS': {
            let productObj = !!state.product ? state.product : new Product();
            return productObj.queryProducts(action.payload || {})
                .then(() => {
                    return Promise.resolve({
                        ...state,
                        product: productObj
                    })
                }).catch((err) => {
                    return Promise.resolve({
                        ...state,
                        product: productObj,
                        error: err
                    });
                });

            return Promise.resolve(state);
        }
        case 'SET_LOCALE': {
            let currentLocale = state.locale.getCurrentLocale().lang
            state.locale.setLocale(action.payload.countryid);
            gaEventTracker('localisation','change-database-' + currentLocale + '-' + state.locale.getCurrentLocale().lang);
            return Promise.resolve({
                ...state
            })
        }
        case 'TRACK_EVENT': {
            gaEventTracker(action.payload.event, action.payload.label);
            return Promise.resolve({
                ...state
            })
        }
        default:
            return state;
    }


};

export default Reducer;